var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("breadcrumb.unit_beacons")))
      ]),
      _c(
        "nav",
        { staticClass: "level" },
        [
          _c("TablePagination", {
            attrs: {
              perPage: _vm.pageFilters.perPage,
              currentPage: _vm.pageFilters.currentPage,
              numofPage: _vm.numofPage
            },
            on: {
              "update:perPage": function($event) {
                return _vm.$set(_vm.pageFilters, "perPage", $event)
              },
              "update:per-page": function($event) {
                return _vm.$set(_vm.pageFilters, "perPage", $event)
              },
              "update:currentPage": function($event) {
                return _vm.$set(_vm.pageFilters, "currentPage", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.pageFilters, "currentPage", $event)
              }
            }
          }),
          _c("div", { staticClass: "level-right" }, [
            _vm.checkedRows.length && _vm.canDelete()
              ? _c(
                  "div",
                  { staticClass: "level-item" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { type: "is-danger", "icon-left": "delete" },
                        on: {
                          click: function($event) {
                            return _vm.confirmMultiDelete()
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.$t("delete")) + " "),
                        _c(
                          "b-tag",
                          {
                            staticClass: "ml-2",
                            attrs: { type: "is-danger is-light", rounded: "" }
                          },
                          [_vm._v(" " + _vm._s(_vm.checkedRows.length) + " ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "level-item" }, [
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "p",
                        { staticClass: "control" },
                        [
                          _c(
                            "b-dropdown",
                            {
                              model: {
                                value: _vm.pageFilters.selectedFilter,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.pageFilters,
                                    "selectedFilter",
                                    $$v
                                  )
                                },
                                expression: "pageFilters.selectedFilter"
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  attrs: { slot: "trigger" },
                                  slot: "trigger"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.convertFieldName(
                                          _vm.pageFilters.selectedFilter
                                        )
                                      )
                                    )
                                  ]),
                                  _c("b-icon", { attrs: { icon: "menu-down" } })
                                ],
                                1
                              ),
                              _c(
                                "b-dropdown-item",
                                { attrs: { value: "beacon_uuid" } },
                                [_vm._v(_vm._s(_vm.$t("label.beacon_uuid")))]
                              ),
                              _c(
                                "b-dropdown-item",
                                { attrs: { value: "major" } },
                                [_vm._v("Major")]
                              ),
                              _c(
                                "b-dropdown-item",
                                { attrs: { value: "minor" } },
                                [_vm._v("Minor")]
                              ),
                              _vm.pageFilters.activeTab === 0
                                ? _c(
                                    "b-dropdown-item",
                                    { attrs: { value: "location_name" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("label.possition")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.pageFilters.activeTab === 0
                                ? _c(
                                    "b-dropdown-item",
                                    { attrs: { value: "floor_name" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("label.floor")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("FilterDropdown", {
                        attrs: {
                          pageFilters: _vm.pageFilters,
                          filteredData: _vm.filteredData
                        },
                        on: {
                          "update:pageFilters": function($event) {
                            _vm.pageFilters = $event
                          },
                          "update:page-filters": function($event) {
                            _vm.pageFilters = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "b-tabs",
        {
          staticClass: "block people-thing-tabs",
          model: {
            value: _vm.pageFilters.activeTab,
            callback: function($$v) {
              _vm.$set(_vm.pageFilters, "activeTab", $$v)
            },
            expression: "pageFilters.activeTab"
          }
        },
        [
          _c("b-tab-item", {
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function() {
                  return [
                    _c("b-icon", { attrs: { icon: "access-point" } }),
                    _c(
                      "span",
                      [
                        _vm._v(" " + _vm._s(_vm.$t("label.static")) + " "),
                        _c("b-tag", { attrs: { rounded: "" } }, [
                          _vm._v(" " + _vm._s(_vm.totalBeaconsStatic) + " ")
                        ])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("b-tab-item", {
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function() {
                  return [
                    _c("b-icon", { attrs: { icon: "transit-transfer" } }),
                    _c(
                      "span",
                      [
                        _vm._v(" " + _vm._s(_vm.$t("label.carried")) + " "),
                        _c("b-tag", { attrs: { rounded: "" } }, [
                          _vm._v(" " + _vm._s(_vm.totalBeaconsCarried) + " ")
                        ])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.isLoading ? [] : _vm.filteredData,
            narrowed: true,
            paginated: true,
            "per-page": _vm.pageFilters.perPage,
            striped: true,
            hoverable: true,
            "current-page": _vm.pageFilters.currentPage,
            "pagination-size": "is-small",
            "checked-rows": _vm.checkedRows,
            "is-row-checkable": function(row) {
              return _vm.canDelete()
            },
            checkable: "",
            "checkbox-position": _vm.checkboxPosition,
            "default-sort": _vm.tableSortSettings,
            "aria-next-label": "Next page",
            "aria-previous-label": "Previous page",
            "aria-page-label": "Page",
            "aria-current-label": "Current page"
          },
          on: {
            "update:perPage": function($event) {
              return _vm.$set(_vm.pageFilters, "perPage", $event)
            },
            "update:per-page": function($event) {
              return _vm.$set(_vm.pageFilters, "perPage", $event)
            },
            "update:currentPage": function($event) {
              return _vm.$set(_vm.pageFilters, "currentPage", $event)
            },
            "update:current-page": function($event) {
              return _vm.$set(_vm.pageFilters, "currentPage", $event)
            },
            "update:checkedRows": function($event) {
              _vm.checkedRows = $event
            },
            "update:checked-rows": function($event) {
              _vm.checkedRows = $event
            }
          }
        },
        [
          _vm._t("columns"),
          _c("b-table-column", {
            attrs: {
              field: "beacon_uuid",
              label: _vm.$t("label.beacon_uuid"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c("span", { attrs: { "data-uuid": props.row._id } }, [
                      _vm._v(" " + _vm._s(props.row.beacon_uuid || "-") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { field: "type", label: _vm.$t("label.type"), sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c("span", { staticClass: "is-capitalized" }, [
                      _vm._v(_vm._s(props.row.beacon_type))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { field: "major", label: "Major/Minor", sortable: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(props.row.major || "-") +
                        "/" +
                        _vm._s(props.row.minor || "-") +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "user_name",
              label: _vm.$t("label.username"),
              visible: _vm.pageFilters.activeTab === 1,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.user_name || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "category_name",
              label: _vm.$t("label.category_name"),
              visible: _vm.pageFilters.activeTab === 1,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.category_name || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "location_name",
              label: _vm.$t("label.possition"),
              visible: _vm.pageFilters.activeTab === 0,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm._v(" " + _vm._s(props.row.location_name || "-") + " ")
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "floor_name",
              label: _vm.$t("label.floor"),
              visible: _vm.pageFilters.activeTab === 0,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.floor_name || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "lat",
              label: _vm.$t("label.lat"),
              visible: _vm.pageFilters.activeTab === 0,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.lat || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "lon",
              label: _vm.$t("label.lon"),
              visible: _vm.pageFilters.activeTab === 0,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.lon || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "lon",
              label: _vm.$t("label.camera"),
              visible: _vm.pageFilters.activeTab === 0,
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    props.row.camera_address
                      ? _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            type: "is-success",
                            icon: "check-circle-outline"
                          }
                        })
                      : _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "minus-circle-outline"
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { width: "100", field: "edit", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm.canDelete()
                      ? _c(
                          "button",
                          {
                            staticClass: "button is-text is-action",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.confirmSingleDelete(props.row)
                              }
                            }
                          },
                          [
                            _c("b-icon", {
                              attrs: { size: "is-small", icon: "delete" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          !_vm.isLoading
            ? _c("template", { slot: "empty" }, [_c("NotFound")], 1)
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }